interface PriceProps {
  price: number | null;
}

export default function Price({ price }: PriceProps) {
  if (price === null) {
    return (
      <div className="flex w-auto items-center justify-center whitespace-nowrap px-2 text-sm font-bold tracking-wide sm:text-xl lg:text-3xl">
        <span className="rounded bg-red-800 px-2 py-1 text-center text-gray-100">לא במלאי</span>
      </div>
    );
  }

  return (
    <div className="flex w-auto items-center justify-center whitespace-nowrap px-2 text-xl font-bold tracking-wide text-blue-800 sm:text-3xl dark:text-sky-100">
      {price}₪
    </div>
  );
}
